<div class="card">
    <div class="card-body d-flex">
        ​<h3>No Record Found</h3> <button class="btn btn-primary ms-4" (click)="onRevise()">Revise Search Criteria</button>
    </div>
</div>